"use strict";
import tmi from "./tmi/Tmi.js";
import art from "./art/Art.js";
import tpc from "./art/Topic.js";
import object_pb from "./Object_pb.js";
import market_pb from "./Market_pb.js";
import ctpfront_pb from "./CtpFront_pb.js";
import WebSocketProtocol from "./art/WebSocketProtocol.js";
import model from "./Model.js";

////////////////////////////////////////////////////////////////////////////////
// 前置机客户端：构造函数
function Front() {
  // 登录信息
  this.websocket = new WebSocketProtocol();
  this.user = null;
  this.init = false;
  this.loginReq = null;

  // 行情Tick数据
  this.tick = new tpc.ObjectTopic();
  this.kbar = new tpc.ObjectTopic();
  this.flash = new tpc.ObjectTopic();
  this.selected = new tpc.ObjectTopic();
  this.dominant = new tpc.ObjectTopic();
  this.condition = new tpc.ObjectTopic();

  // 合约列表
  this.targetList; // 合约列表数组
  this.targetSet; // 合约列表集合
  this.exchangeSet; // 交易所集合
  this.productSet; // 品种集合
}
var impl = {};


////////////////////////////////////////////////////////////////////////////////
// 设置合约列表
impl.setTargetList = function (front, targetList) {
  front.targetSet = {};
  front.exchangeSet = {};
  front.productSet = {};
  for (var i = 0; i < targetList.length; ++i) {
    var target = targetList[i];
    front.targetSet[target.targetId] = target;
    // 商品列表
    var product = front.productSet[target.productId];
    if (product === undefined) {
      front.productSet[target.productId] = product = {};
      product.targetSet = [];
      product.id = target.productId;
      product.name = target.productName;
    }
    product.targetSet.push({
      id: target.targetId,
      name: target.targetName
    });
    // 交易所列表
    var exchange = front.exchangeSet[target.exchangeId];
    if (exchange === undefined) {
      front.exchangeSet[target.exchangeId] = exchange = {};
      exchange.productSet = [];
      exchange.id = target.exchangeId;
      exchange.name = target.exchangeName;
    }
    exchange.productSet.push({
      id: target.productId,
      name: target.productName
    });
  }
}


////////////////////////////////////////////////////////////////////////////////
// 接口消息ID
Front.proto_login_req = 10001,
  Front.proto_login_rsp = 10002,
  Front.proto_insert_order_req = 10003,
  Front.proto_insert_order_rsp = 10004,
  Front.proto_cancel_order_req = 10005,
  Front.proto_cancel_order_rsp = 10006,
  Front.proto_order_pub = 10007,
  Front.proto_trade_pub = 10008,
  Front.proto_capital_req = 10011,
  Front.proto_capital_rsp = 10012,
  Front.proto_position_req = 10013,
  Front.proto_position_rsp = 10014,
  Front.proto_position_detail_req = 10015,
  Front.proto_position_detail_rsp = 10016,
  Front.proto_max_order_volume_req = 10017,
  Front.proto_max_order_volume_rsp = 10018,
  Front.proto_insinfo_req = 10019,
  Front.proto_insinfo_rsp = 10020,
  Front.proto_kbar_req = 10021,
  Front.proto_kbar_rsp = 10022,
  Front.proto_lstquote_req = 10023,
  Front.proto_lstquote_rsp = 10024,
  Front.proto_alltickquote_req = 10025,
  Front.proto_alltickquote_rsp = 10026,
  // 订阅行情快照（行情列表）
  Front.proto_tick_sub_req = 10030,
  Front.proto_tick_sub_rsp = 10031,
  Front.proto_tick_unsub_req = 10032,
  Front.proto_tick_unsub_rsp = 10033,
  Front.proto_tick_pub = 10034,
  // 订阅行情K线（1分钟/5分钟）
  Front.proto_kbar_sub_req = 10040,
  Front.proto_kbar_sub_rsp = 10041,
  Front.proto_kbar_unsub_req = 10042,
  Front.proto_kbar_unsub_rsp = 10043,
  Front.proto_kbar_pub = 10044,
  // 订阅行情分时图（1分钟）
  Front.proto_time_seq_req = 10055,
  Front.proto_time_seq_rsp = 10056,
  // 自选股
  Front.proto_target_selected_sub_req = 10060,
  Front.proto_target_selected_sub_rsp = 10061,
  Front.proto_target_selected_unsub_req = 10062,
  Front.proto_target_selected_unsub_rsp = 10063,
  Front.proto_target_selected_add_req = 10064,
  Front.proto_target_selected_add_rsp = 10065,
  Front.proto_target_selected_remove_req = 10066,
  Front.proto_target_selected_remove_rsp = 10067,
  Front.proto_target_selected_pub = 10068,
  // 主力合约
  Front.proto_target_dominant_sub_req = 10070,
  Front.proto_target_dominant_sub_rsp = 10071,
  Front.proto_target_dominant_unsub_req = 10072,
  Front.proto_target_dominant_unsub_rsp = 10073,
  Front.proto_target_dominant_pub = 10074,
  // 条件单
  Front.proto_order_conditional_sub_req = 10080,
  Front.proto_order_conditional_sub_rsp = 10081,
  Front.proto_order_conditional_unsub_req = 10082,
  Front.proto_order_conditional_unsub_rsp = 10083,
  Front.proto_order_conditional_save_req = 10084,
  Front.proto_order_conditional_save_rsp = 10085,
  Front.proto_order_conditional_remove_req = 10086,
  Front.proto_order_conditional_remove_rsp = 10087,
  Front.proto_order_conditional_pub = 10088,
  Front.proto_order_conditional_get_req = 10089,
  Front.proto_order_conditional_get_rsp = 10090,

  // 修改密码
  Front.proto_user_passwd_update_req = 10093,
  Front.proto_user_passwd_update_rsp = 10094,

  ////////////////////////////////////////////////////////////////////////////////
  // 错误ID
  Front.prototype.e_network = -5, // 网络错误
  Front.prototype.e_selected_not_exist = 10001, // 自选股合约不存在
  Front.prototype.e_selected_repeated = 10002, // 自选股重复添加
  Front.prototype.e_selected_removed = 10003, // 自选股重复删除
  Front.prototype.e_unknown = 10004, // 未知错误
  Front.prototype.e_account_invalid = 11, // 用户名不正确
  Front.prototype.e_password_invalid = 2001, // 用户密码不正确

  ////////////////////////////////////////////////////////////////////////////////
  // 买卖
  Front.prototype.direct_buy = 1; // 买（多头）
Front.prototype.direct_sell = 2; // 卖（空头）
// 持仓方向
Front.prototype.pos_direct_long = 1, // 多头
  Front.prototype.pos_direct_short = 2, // 空头
  Front.prototype.pos_direct_net = 3, // 净持仓
  // 开平
  Front.prototype.offset_open = 1; // 开仓
Front.prototype.offset_close = 2; // 平仓
Front.prototype.offset_close_today = 3; // 平今
Front.prototype.offset_close_last = 4; // 平昨
// 投机套利
Front.prototype.hedge_speculation = 1, // 投机
  Front.prototype.hedge_arbitrage = 2, // 套利
  Front.prototype.hedge_hedge = 3, // 套保

  // 国内股票交易所
  Front.prototype.exchange_sse = 1, // 上交所（股票）
  Front.prototype.exchange_sze = 2, // 深交所（股票）
  // 国内期货交易所
  Front.prototype.exchange_shfe = 3, // 上期所（期货）
  Front.prototype.exchange_cffex = 4, // 中金所（期货）
  Front.prototype.exchange_dce = 5, // 大商所（期货）
  Front.prototype.exchange_czce = 6, // 郑商所（期货）
  Front.prototype.exchange_ine = 7, // 上海国际能源（期货）
  Front.prototype.exchange_gfex = 8, // 广期所

  // 委托状态：股票\期货
  Front.prototype.order_init = 101, // 就绪
  Front.prototype.order_sended = 102, // 已发送
  Front.prototype.order_accepted = 104, // 未成交（已报单）
  Front.prototype.order_cancel_sended = 106, // 撤单已发
  Front.prototype.order_cancel_accepted = 105, // 撤单已报
  Front.prototype.order_part_canceled = 107, // 部分撤单
  Front.prototype.order_all_canceled = 108, // 全部撤单
  Front.prototype.order_part_traded = 110, // 部分成交
  Front.prototype.order_all_traded = 111, // 全部成交
  Front.prototype.order_error = 113, // 错单

  // 行情K线类型
  Front.prototype.ktype_tick = 1, // Tick
  Front.prototype.ktype_second = 2, // 秒
  Front.prototype.ktype_minute = 3, // 分
  Front.prototype.ktype_hour = 4, // 小时
  Front.prototype.ktype_day = 5, // 天
  Front.prototype.ktype_week = 6, // 周
  Front.prototype.ktype_month = 7, // 月
  Front.prototype.ktype_season = 8, // 月
  Front.prototype.ktype_year = 9, // 年

  // 行情K线查询模式
  Front.prototype.kquery_time = 1; // 按时间查询
Front.prototype.kquery_size = 2; // 按K线数查询
Front.prototype.kquery_days = 3; // 按交易日查询

////////////////////////////////////////////////////////////////////////////////
// 条件单类型
Front.prototype.con_no_active = 0, //未触发
  Front.prototype.con_active = 1, //已触发

  // 条件单 价格类型
  Front.prototype.con_limit_price = 2, //限价
  Front.prototype.con_opponent_price = 16, //对手价
  Front.prototype.con_last_price = 4, //最新价
  Front.prototype.con_market_price = 17, //市价
  Front.prototype.con_plusone_tick_price = 18, //超一价

  // 条件单 有效期类型
  Front.prototype.con_validity_gfd = 0, //当日有效
  Front.prototype.con_validity_all = 1, //永久有效

  // 条件单运行状态
  Front.prototype.con_order_run = 1, //运行中
  Front.prototype.con_order_stop = 2, //暂停
  Front.prototype.con_order_trigger = 3, //已触发
  Front.prototype.con_order_delete = 4, //已删除
  Front.prototype.con_order_settlement = 5, //已结算

  // Front.prototype.con_state_run               = 1,    //运行中
  // Front.prototype.con_state_stop              = 2,    //停止
  // Front.prototype.con_state_trigger           = 3,    //暂停

  // 条件单 操作
  Front.prototype.con_operation2_add = 0, //增加
  Front.prototype.con_operation2_update = 1, //更新
  Front.prototype.con_operation2_delete = 2, //删除

  // 条件单 运算符
  Front.prototype.con_operation_gt = 0, //大于
  Front.prototype.con_operation_lt = 1, //小于
  Front.prototype.con_operation_ge = 2, //大于等于
  Front.prototype.con_operation_le = 3, //小于等于


  ////////////////////////////////////////////////////////////////////////////////
  // 买卖方向
  Front.prototype.textDirection = function (direct) {
    var text = (direct == Front.prototype.direct_buy) ? "买" : "卖";
    return text;
  }
// 开平方向
Front.prototype.textOffSet = function (offset) {
  var text = (offset == Front.prototype.offset_open) ? "开" : "平";
  return text;
}
// 买卖开平
Front.prototype.textDirectionOffSet = function (direct, offset) {
  var text = (direct == Front.prototype.direct_buy) ? "买" : "卖";
  text += (offset == Front.prototype.offset_open) ? "开" : "平";
  return text;
}
// 持仓方向
Front.prototype.textPositionDirection = function (direct) {
  var text = (direct == Front.prototype.pos_direct_long) ? "买" : "卖";
  return text;
}


////////////////////////////////////////////////////////////////////////////////
// 委托状态
Front.prototype.textOrderState = function (state) {
  switch (state) {
    case Front.prototype.order_accepted:
      return "未成交";
    case Front.prototype.order_all_traded:
      return "全部成交";
    case Front.prototype.order_all_canceled:
      return "已撤单";
    case Front.prototype.order_error:
      return "已撤单";
    case Front.prototype.order_part_canceled:
      return "部分撤单";
    case Front.prototype.order_part_traded:
      return "部分成交";
  }
  return "";
}


////////////////////////////////////////////////////////////////////////////////
// 套利
Front.prototype.textHedge = function (hedge) {
  switch (hedge) {
    case Front.prototype.hedge_speculation:
      return "投机";
    case Front.prototype.hedge_arbitrage:
      return "套利";
    case Front.prototype.hedge_hedge:
      return "套保";
  }
  return "";
}


////////////////////////////////////////////////////////////////////////////////
// 获取持仓的平仓方向
Front.prototype.getCloseOrderDirection = function (pos_direct) {
  switch (pos_direct) {
    case Front.prototype.pos_direct_long:
      return Front.prototype.direct_sell;
    case Front.prototype.pos_direct_short:
      return Front.prototype.direct_buy;
    case Front.prototype.pos_direct_net:
      return Front.prototype.direct_sell;
  }
  return 0;
}
// 获取持仓的平仓方向
Front.prototype.getPositionDirection = function (order_direct) {
  switch (order_direct) {
    case Front.prototype.direct_sell:
      return Front.prototype.pos_direct_short;
    case Front.prototype.direct_buy:
      return Front.prototype.pos_direct_long;
  }
  return 0;
}
// 获取委托方向取反
Front.prototype.getReverseDirection = function (direct) {
  switch (direct) {
    case Front.prototype.direct_sell:
      return Front.prototype.direct_buy;
    case Front.prototype.direct_buy:
      return Front.prototype.direct_sell;
  }
  return 0;
}

//
Front.prototype.getConditionOrderActive = function (state) {
  switch (state) {
    case Front.prototype.con_state_run:
    case Front.prototype.con_state_stop:
      return Front.prototype.con_no_active;
    case Front.prototype.con_state_trigger:
      return Front.prototype.con_active;
  }
  return 0;
}

////////////////////////////////////////////////////////////////////////////////
// 获取持仓的可用数量
Front.prototype.getPositionVailable = function (pos) {
  return (pos.lastVolume + pos.todayVolume - pos.frozenVolume);
}


////////////////////////////////////////////////////////////////////////////////
// 获取持仓的平仓方向
Front.prototype.getCloseOrderSet = function (orderSet, pos, volume, price) {
  if (this.getPositionVailable(pos) < volume) {
    return; // 下单数量超出持仓数量
  }

  var that = this;
  // 计算除去冻结仓位的今仓与昨仓。
  var frozenLastVolume = pos.frozenVolume - pos.frozenTodayVolume;
  var lastVolume = pos.lastVolume - frozenLastVolume;
  var tdayVolume = pos.todayVolume - pos.frozenTodayVolume;

  // 计算今仓与昨仓的平仓数量。
  var left = volume - lastVolume;
  var direct = that.getCloseOrderDirection(pos.direction);
  if (left <= 0) {
    orderSet.push(that.makeOrder(
      pos.targetId, direct, that.offset_close_last, volume, price));
  } else {
    // 平完昨仓平今仓
    if (lastVolume > 0) {
      orderSet.push(that.makeOrder(
        pos.targetId, direct, that.offset_close_last, lastVolume, price));
    }
    orderSet.push(that.makeOrder(
      pos.targetId, direct, that.offset_close_today, left, price));
  }
}


////////////////////////////////////////////////////////////////////////////////
Front.prototype.makeOrder = function (targetId, direct, offset, volume, price) {
  var order = new ctpfront_pb.Order();
  order.setOrderRef(this.getNextOrderRef());
  order.setTargetId(targetId);
  order.setVolume(volume);
  order.setPrice(price);
  order.setOffset(offset);
  order.setDirection(direct);
  return order;
}


////////////////////////////////////////////////////////////////////////////////
// 格式化各个信息
Front.prototype.formatTick = function (quote) {
  quote.priceTick = Math.round(quote.priceTick * 1000000) / 1000000;
  var bit = art.digit(quote.priceTick);
  quote.latestPrice = quote.latestPrice.toFixed(bit);
  quote.askPrice1 = quote.askPrice1.toFixed(bit);
  quote.bidPrice1 = quote.bidPrice1.toFixed(bit);
  quote.highPrice = quote.highPrice.toFixed(bit);
  quote.highStopPrice = quote.highStopPrice.toFixed(bit);
  quote.lastClosePrice = quote.lastClosePrice.toFixed(bit);
  quote.lastSettlementPrice = quote.lastSettlementPrice.toFixed(bit);
  quote.lowPrice = quote.lowPrice.toFixed(bit);
  quote.lowStopPrice = quote.lowStopPrice.toFixed(bit);
  quote.openPrice = quote.openPrice.toFixed(bit);
  quote.settlementPrice = quote.settlementPrice.toFixed(bit);
}

////////////////////////////////////////////////////////////////////////////////
// 清理数据。
impl.clear = function (front) {
  front.user = null;
  front.init = false;
  front.tick.clear();
  front.kbar.clear();
  front.flash.clear();
  front.selected.clear();
  front.condition.clear();
  front.dominant.clear();
  art.clear(front.targetList);
  art.clear(front.targetSet);
  art.clear(front.exchangeSet);
  art.clear(front.productSet);
  model.release();
}


////////////////////////////////////////////////////////////////////////////////
// 网络断开通知。
// @onClose.activeClose：是否主动断开连接。
Front.prototype.setEvent = function (onOpen, onClose) {
  this.websocket.setEvent(
    onOpen, (active) => onClose(active), () => impl.clear(this));
}
Front.prototype.close = function () {
  this.websocket.close();
}
Front.prototype.opened = function () {
  this.websocket.opened();
}


////////////////////////////////////////////////////////////////////////////////
// 程序异常断开时，自动加载当前页面数据。
Front.prototype.autoMount = function (pageMount) {
  var that = this;
  var login = function (resolve, reject) {
    var option = {
      upgrade: function (user) {
        return false;
      },
      resolve: function (user) {
        resolve();
      },
      loginReject: function (error) {
        reject();
      }
    }
    that.login_do(
      that.loginReq.getAccount(),
      that.loginReq.getPassword(),
      option);
  }
  that.websocket.mount(pageMount, login, art.bind(that, that.ready));
}


////////////////////////////////////////////////////////////////////////////////
// 初始化就绪
Front.prototype.ready = function () {
  var that = this;
  return (that.user != null && that.init);
}


////////////////////////////////////////////////////////////////////////////////
// 前置机登录：手动登录。
Front.prototype.login = function (address, account, password, option) {
  var that = this;
  var addressSet = [];
  that.close();
  /*
  if (process.env.NODE_ENV === 'development')
    console.log('env:' + process.env.NODE_ENV);
  addressSet.push("ws://" + address + ":42205");
  // if(process.env.NODE_ENV === 'production'){
  addressSet.push("ws://" + address + ":42206");
  addressSet.push("ws://" + address + ":42207");
  addressSet.push("ws://" + address + ":42208");
  addressSet.push("ws://" + address + ":42209");
  // }
  */

  addressSet.push("ws://" + address + ":43205");
  addressSet.push("ws://" + address + ":43206");
  that.websocket.setAddress(address, addressSet);

  // 手动登录失败，需断开连接（避免登录前断开服务端会有断开延迟，导致登录）
  option.loginReject = function (error) {
    option.reject(error);
    that.close();
  };
  that.login_do(account, password, option);
}

Front.prototype.regReconnect = function (fun) {
  this._regreconnect = fun;
}

////////////////////////////////////////////////////////////////////////////////
// 前置机登录
Front.prototype.login_do = function (account, password, option) {
  var that = this;
  if (process.env.NODE_ENV === 'development')
    console.log('login_do');
  // #1.登录初始化：查询持仓列表。
  var init_position = function () {
    model.trader.position.query(function () {
      that.init = true;
      if (process.env.NODE_ENV === 'development')
        console.log("init position ok");
      option.resolve(that.user);
    }, function (error) {
      option.loginReject(error);
    }, 13000);
  };

  // #2.登录初始化：查询合约列表。
  var init_target = function () {
    that.queryTarget("", function (dataList) {
      that.targetList = dataList;
      impl.setTargetList(that, that.targetList);
      if (process.env.NODE_ENV === 'development')
        console.log("init target ok");
      init_position();
    }, function (error) {
      option.loginReject(error);
    });
    if (that._regreconnect) {
      that._regreconnect();
    }
  };

  // #3.登录初始化：委托与成交数据。
  that.websocket.subscribe(Front.proto_order_pub, ctpfront_pb.Order,
    function (pub) {
      model.trader.onOrder(pub)
    });
  that.websocket.subscribe(Front.proto_trade_pub, ctpfront_pb.Trade,
    function (pub) {
      model.trader.onTrade(pub, that.init)
    });
  // #4.登录系统
  impl.clear(that);
  that.loginReq = new ctpfront_pb.LoginReq();
  that.loginReq.setAccount(account);
  that.loginReq.setPassword(password);
  that.loginReq.reqType = Front.proto_login_req;
  that.websocket.send(that.loginReq, ctpfront_pb.LoginRsp, {
    timeout: 10000,
    resolve: function (user) {
      that.user = user;
      if (process.env.NODE_ENV === 'development')
        console.log("init login ok");
      // 自动升级
      if (option.upgrade(user)) return;
      init_target();
    },
    reject: function (error) {
      option.loginReject(error);
    }
  });
}


////////////////////////////////////////////////////////////////////////////////
/**
 * 修改账户密码
 * @param {String} pwd_old 旧密码。
 * @param {String} pwd_new 新密码。
 */
Front.prototype.updatePassword = function (pwd_old, pwd_new, resolve, reject) {
  var that = this;
  if (that.ready()) {
    var req = new ctpfront_pb.UserPasswdUpdateReq();
    req.setOldPasswd(pwd_old);
    req.setNewPasswd(pwd_new);
    req.setBroker(that.user.broker);
    req.setUserId(that.user.account);
    req.reqType = Front.proto_user_passwd_update_req;
    that.websocket.send(req, ctpfront_pb.UserPasswdUpdateRsp, {
      resolve,
      reject
    });
  }
}


////////////////////////////////////////////////////////////////////////////////
// 查询资金。
Front.prototype.queryCapital = function (onRsp) {
  var that = this;
  if (that.ready()) {
    var req = new ctpfront_pb.CapitalReq();
    req.reqType = Front.proto_capital_req;
    that.websocket.send(req, ctpfront_pb.CapitalRsp, {
      control: {
        discard: true,
        interval: 2000
      },
      resolve: function (data) {
        onRsp(data);
      },
      reject: function (error) {
        onRsp(undefined, error);
      }
    });
  }
}


////////////////////////////////////////////////////////////////////////////////
// 获取报单引用
Front.prototype.getNextOrderRef = function () {
  var that = this;
  if (!that.ready()) {
    return;
  }
  // OrderRef的生成算法参照：ctp::get_order_ref().
  var order_ref = ++that.user.maxOrderRef;
  var result = "#";
  result += that.user.frontId;
  result += "#";
  result += that.user.sessionId;
  result += "#";
  result += order_ref;
  return result;
}


////////////////////////////////////////////////////////////////////////////////
// 查询持仓信息。
Front.prototype.queryPosition = function (target_id, resolve, reject, millsec) {
  var that = this;
  if (that.user != null) {
    var req = new ctpfront_pb.PositionReq();
    req.setTargetId(target_id);
    req.reqType = Front.proto_position_req;
    that.websocket.send(req, ctpfront_pb.PositionRsp, {
      reject: reject,
      resolve: resolve,
      control: {
        discard: false,
        taskName: "position"
      },
      // 获取持仓失败，则强制断开。
      timeout: millsec,
      timeoutClose: true,
    });
  }
}


////////////////////////////////////////////////////////////////////////////////
// 委托下单。
Front.prototype.insertOrder = function (order, resolve, reject) {
  var that = this;
  if (that.ready()) {
    order.reqType = Front.proto_insert_order_req;
    that.websocket.send(order, ctpfront_pb.InsertOrderRsp, {
      resolve: resolve,
      reject: reject,
      timeout: 0,
    });
  }
}


////////////////////////////////////////////////////////////////////////////////
// 取消订单。
Front.prototype.cancelOrder = function (corder, resolve, reject) {
  var that = this;
  if (that.ready()) {
    corder.reqType = Front.proto_cancel_order_req;
    that.websocket.send(corder, ctpfront_pb.CancelOrderRsp, {
      resolve: resolve,
      reject: reject,
      timeout: 0,
    });
  }
}


////////////////////////////////////////////////////////////////////////////////
// 查询合约列表。
Front.prototype.productTarget = function (productId) {
  var ids = [];
  var list = this.productSet[productId];
  if (list !== undefined) {
    for (var i = 0; i < list.targetSet.length; ++i) {
      var target = list.targetSet[i];
      ids.push(target.id);
    }
  }
  return ids;
}


////////////////////////////////////////////////////////////////////////////////
// 查询合约列表。
Front.prototype.queryTarget = function (target_id, resolve, reject) {
  var that = this;
  if (that.user != null) {
    var req = new ctpfront_pb.TargetReq();
    req.setTargetId(target_id);
    req.reqType = Front.proto_insinfo_req;
    that.websocket.send(req, ctpfront_pb.TargetRsp, {
      control: {
        discard: false,
        taskName: "target"
      },
      resolve: resolve,
      reject: reject,
    });
  }
}


////////////////////////////////////////////////////////////////////////////////
/**
 * 查询最大开仓数量
 * @param {String} req.targetId 合约代码rb1805。
 * @param {Front.prototype.direct} req.direct 买卖方向
 */
Front.prototype.getMaxOrderVolume = function (req, resolve, reject) {
  var that = this;
  if (that.ready()) {
    var req_pb = new ctpfront_pb.MaxOrderVolume();
    req_pb.setTargetId(req.targetId);
    req_pb.setDirection(req.direct);
    req_pb.reqType = Front.proto_max_order_volume_req;
    that.websocket.send(req_pb, ctpfront_pb.MaxOrderVolumeRsp, {
      timeout: 3000,
      resolve,
      reject,
    });
  }
}


////////////////////////////////////////////////////////////////////////////////
/*@订阅行情Tick：交易界面；行情界面。
* @para.targetId：合约ID或者品种ID。
* @para.suber: 订阅者ID，或者订阅者。

* @案例：
1.按单个合约订阅。
subTick("rbn805", "trade_page");
2.按品种订阅。
subTick("rb", {
    suberId: "trade_page",
    publish: function(tick) {}
});
*/
Front.prototype.subTick = function (targetId, suber) {
  let that = this;
  if (!that.ready()) {
    return;
  }

  // 本地订阅发布管理
  var option = tmi.isProduct(targetId) ? {
    suber: suber,
    topicId: targetId,
    topicType: tpc.SetTopic,
    topicSelect: that.productTarget(targetId),
    topicGroup: {
      groupId: "product",
      topicId: (tick) => {
        return tmi.productId(tick.targetId);
      }
    },
  } : {
    suber: suber,
    topicId: targetId,
    topicType: tpc.OneTopic,
    topicGroup: {
      groupId: "target",
      topicId: (tick) => {
        return tick.targetId;
      }
    },
  };

  // 若是第一次订阅数据，则从后台服务器订阅
  var result = that.tick.subscribe(option);
  if (result.sub) {
    that.websocket.subscribe(
      Front.proto_tick_pub, ctpfront_pb.Quote, (pub) => {
        that.formatTick(pub);
        that.tick.publish(pub, pub.targetId);
      });
    var req = new ctpfront_pb.SubTickReq();
    req.reqType = Front.proto_tick_sub_req;
    req.setTargetList(result.sub);
    that.websocket.send(req, ctpfront_pb.SubTickRsp, {
      resolve: (suber === undefined) ? suber : suber.resolve,
      reject: (suber === undefined) ? that.onError : suber.reject
    });
  }
  return result.subject;
}


////////////////////////////////////////////////////////////////////////////////
// 取消订阅Tick行情
Front.prototype.unsubTick = function (targetId, suberId) {
  let that = this;
  if (!that.ready()) {
    return;
  }
  // 从主题中移除订阅者
  // 若主题不存在订阅者，则取消服务器端的订阅。
  var unsubs = this.tick.unsubscribe(targetId, suberId);
  if (unsubs) {
    var req = new ctpfront_pb.SubTickReq();
    req.reqType = Front.proto_tick_unsub_req;
    req.setTargetList(unsubs);
    that.websocket.send(req, ctpfront_pb.SubTickRsp, {
      timeout: 0
    });
  }
}

////////////////////////////////////////////////////////////////////////////////
// 关闭API，关闭网络。
impl.getTopicId = function (targetId, ktype, kunit) {
  return targetId + "#" + ktype + "#" + kunit;
}


////////////////////////////////////////////////////////////////////////////////
/*@订阅行情数据Kbar
 * @targetId：合约ID（如rb1805）
 * @ktype：K线类型，参见Front.prototype.ktype
 * @kunit：K线单位。
 */
Front.prototype.subKbar = function (targetId, ktype, kunit, suber) {
  let that = this;
  if (!that.ready()) {
    return;
  }

  // 本地订阅发布管理
  var option = {
    suber: suber,
    topicId: impl.getTopicId(targetId, ktype, kunit),
    topicType: tpc.SeqTopic,
    topicGroup: {
      groupId: "kbar",
      topicId: function (kbar) {
        if (process.env.NODE_ENV === 'development')
          console.log(kbar);
        return impl.getTopicId(kbar.targetId, kbar.ktype, kbar.kunit);
      }
    },
  };

  // 若是第一次订阅数据，则从后台服务器订阅
  var result = that.kbar.subscribe(option);
  if (result.sub) {
    that.websocket.subscribe(Front.proto_kbar_pub, market_pb.Kbar,
      (pub, snap) => that.kbar.publish(pub, undefined, snap));
    var req = new market_pb.SubKbar();
    req.reqType = Front.proto_kbar_sub_req;
    req.setTargetId(targetId);
    req.setKtype(ktype);
    req.setKunit(kunit);
    that.websocket.send(req, market_pb.SubKbarRsp, {
      resolve: (suber === undefined) ? suber : suber.resolve,
      reject: (suber === undefined) ? that.onError : suber.reject
    });
  }
  return result.subject;
}
// 取消订阅行情K线
Front.prototype.unsubKbar = function (targetId, ktype, kunit, suberId) {
  let that = this;
  if (!that.ready()) {
    return;
  }
  // 从主题中移除订阅者
  // 若主题不存在订阅者，则取消服务器端的订阅。
  var topicId = impl.getTopicId(targetId, ktype, kunit);
  if (process.env.NODE_ENV === 'development')
    console.log("unsubKbar" + topicId);
  var unsubs = this.kbar.unsubscribe(topicId, suberId);
  if (unsubs) {
    var req = new market_pb.SubKbar();
    req.reqType = Front.proto_kbar_unsub_req;
    req.setTargetId(targetId);
    req.setKtype(ktype);
    req.setKunit(kunit);
    that.websocket.send(req, market_pb.SubKbarRsp);
  }
}


////////////////////////////////////////////////////////////////////////////////
// 查询合约时间序列。
Front.prototype.getKbarTimeSeq = function (
  targetId, ktype, kunit, resolve, reject) {
  var that = this;
  if (that.ready()) {
    var req = new market_pb.TimeSeqReq();
    req.setTargetId(targetId);
    req.setKtype(ktype);
    req.setKunit(kunit);
    req.reqType = Front.proto_time_seq_req;
    that.websocket.send(req, market_pb.TimeSeqRsp, {
      resolve,
      reject
    });
  }
}


////////////////////////////////////////////////////////////////////////////////
/* @添加自选股*/
Front.prototype.selectedTargetAdd = function (targetId, resolve, reject) {
  var that = this;
  if (that.ready()) {
    var req = new ctpfront_pb.TargetSelected();
    req.setTargetId(targetId);
    req.reqType = Front.proto_target_selected_add_req;
    that.websocket.send(req, ctpfront_pb.TargetSelectedRsp, {
      resolve: resolve,
      reject: reject
    });
  }
}

////////////////////////////////////////////////////////////////////////////////
/* @删除自选股*/
Front.prototype.selectedTargetRemove = function (targetId, resolve, reject) {
  var that = this;
  if (that.ready()) {
    var req = new ctpfront_pb.TargetSelectedReq();
    req.setTargetId(targetId);
    req.reqType = Front.proto_target_selected_remove_req;
    that.websocket.send(req, ctpfront_pb.TargetSelectedRsp, {
      resolve: resolve,
      reject: reject
    });
  }
}

////////////////////////////////////////////////////////////////////////////////
/* @订阅自选股*/
Front.prototype.selectedTargetSub = function (suber) {
  let that = this;
  if (!that.ready()) {
    return;
  }

  // 本地订阅发布管理
  var option = {
    suber: suber,
    topicId: that.user.account,
    topicType: tpc.SetTopic,
    topicSelect: function (pub) {
      return true;
    },
    topicGroup: {
      groupId: "selected",
      topicId: function (pub) {
        return that.user.account;
      }
    },
  };

  // 若是第一次订阅数据，则从后台服务器订阅
  var result = that.selected.subscribe(option);
  if (result.sub) {
    that.websocket.subscribe(
      Front.proto_target_selected_pub, ctpfront_pb.TargetSelected,
      (pub, snap, remove) => that.selected.publish(
        pub, pub.targetId, snap, remove),
    );
    var req = new ctpfront_pb.Subscribe();
    req.reqType = Front.proto_target_selected_sub_req;
    that.websocket.send(req, ctpfront_pb.Response, {
      resolve: (suber === undefined) ? suber : suber.resolve,
      reject: (suber === undefined) ? that.onError : suber.reject
    });
  }
  return result.subject;
}

////////////////////////////////////////////////////////////////////////////////
/* @取消订阅自选股*/
Front.prototype.selectedTargetUnsub = function (suberId) {
  let that = this;
  if (that.ready() && this.selected.unsubscribe(that.user.account, suberId)) {
    var req = new ctpfront_pb.Subscribe();
    req.reqType = Front.proto_target_selected_unsub_req;
    that.websocket.send(req);
  }
}


////////////////////////////////////////////////////////////////////////////////
/* @订阅主力合约
 */
Front.prototype.dominantTargetSub = function (suber) {
  var that = this;
  if (!that.ready()) {
    return;
  }

  // 本地订阅发布管理
  var option = {
    suber: suber,
    topicId: that.user.account,
    topicType: tpc.SetTopic,
    topicGroup: {
      groupId: "dominant",
      topicId: function (d) {
        return that.user.account;
      }
    },
  };

  // 若是第一次订阅数据，则从后台服务器订阅
  var result = that.dominant.subscribe(option);
  if (result.sub) {
    that.websocket.subscribe(
      Front.proto_target_dominant_pub, ctpfront_pb.Dominant,
      (pub, snap) => that.dominant.publish(pub, pub.targetId, snap),
    );
    var req = new ctpfront_pb.Subscribe();
    req.reqType = Front.proto_target_dominant_sub_req;
    that.websocket.send(req, ctpfront_pb.Response, {
      resolve: (suber === undefined) ? suber : suber.resolve,
      reject: (suber === undefined) ? that.onError : suber.reject
    });
  }
  return result.subject;
}

////////////////////////////////////////////////////////////////////////////////
/* @取消订阅主力合约
 */
Front.prototype.dominantTargetUnsub = function (suberId) {
  var that = this;
  if (that.ready() && this.dominant.unsubscribe(that.user.account, suberId)) {
    var req = new ctpfront_pb.Subscribe();
    req.reqType = Front.proto_target_dominant_unsub_req;
    that.websocket.send(req, ctpfront_pb.Response);
  }
}


////////////////////////////////////////////////////////////////////////////////
/* @ 添加与修改条件单
 */
Front.prototype.conditionOrderSave = function (conditionOrder, resolve, reject) {
  var that = this;
  if (that.ready()) {
    var req = conditionOrder;
    req.reqType = Front.proto_order_conditional_save_req;
    that.websocket.send(req, ctpfront_pb.OrderConditionalRsp, {
      resolve: resolve,
      reject: reject
    });
  }
}

////////////////////////////////////////////////////////////////////////////////
/* @ 删除条件单
 */
Front.prototype.conditionOrderRemove = function (broker, account, id,
  resolve, reject) {
  var that = this;
  if (that.ready()) {
    var req = new ctpfront_pb.OrderConditionalReq();
    req.setBroker(broker);
    req.setAccount(account);
    req.setId(id);
    req.reqType = Front.proto_order_conditional_remove_req;
    that.websocket.send(req, ctpfront_pb.OrderConditionalRsp, {
      resolve: resolve,
      reject: reject
    });
  }
}

////////////////////////////////////////////////////////////////////////////////
/* @ 订阅条件单
 */
Front.prototype.conditionOrderSub = function (suber) {
  let that = this;
  if (!that.ready()) {
    return;
  }

  // 本地订阅发布管理
  var option = {
    suber: suber,
    topicId: that.user.account,
    topicType: tpc.SetTopic,
    topicSelect: function (pub) {
      return true;
    },
    topicGroup: {
      groupId: "condition_order",
      topicId: function (pub) {
        return that.user.account;
      }
    },
  };

  // 若是第一次订阅数据，则从后台服务器订阅
  var result = that.condition.subscribe(option);
  if (result.sub) {
    that.websocket.subscribe(
      Front.proto_order_conditional_pub, ctpfront_pb.OrderConditional,
      (pub, snap, remove) => that.condition.publish(
        pub, pub.id, snap, remove),
    );
    var req = new ctpfront_pb.Subscribe();
    req.reqType = Front.proto_order_conditional_sub_req;
    that.websocket.send(req, ctpfront_pb.Response, {
      resolve: (suber === undefined) ? suber : suber.resolve,
      reject: (suber === undefined) ? that.onError : suber.reject
    });
  }
  return result.subject;
}

////////////////////////////////////////////////////////////////////////////////
/* @ 取消订阅条件单
 */
Front.prototype.conditionOrderUnsub = function (suberId) {
  let that = this;
  if (that.ready() && this.condition.unsubscribe(that.user.account, suberId)) {
    var req = new ctpfront_pb.Subscribe();
    req.reqType = Front.proto_order_conditional_unsub_req;
    that.websocket.send(req, ctpfront_pb.Response);
  }
}

////////////////////////////////////////////////////////////////////////////////
/* @ 查询(已触发)条件单
 */
Front.prototype.conditionOrderQry = function (broker, account, start, end, resolve, reject) {
  let that = this;
  if (that.ready()) {
    var req = new ctpfront_pb.OrderConditionGetReq();
    req.setBroker(broker);
    req.setAccount(account);
    req.setStartTime(start);
    req.setLastTime(end);

    req.reqType = Front.proto_order_conditional_get_req;
    that.websocket.send(req, ctpfront_pb.OrderConditionGetRsp, {
      resolve: resolve,
      reject: reject
    });
  }
}


////////////////////////////////////////////////////////////////////////////////
// 接口消息ID
// 订阅行情K线（1分钟/5分钟）
impl.kbar_sub_req = 1050;
impl.kbar_sub_rsp = 1051;
impl.kbar_unsub_req = 1052;
impl.kbar_unsub_rsp = 1053;
impl.kbar_pub = 1054;
impl.kbar_get_req = 1055;
impl.kbar_get_rsp = 1056;
// 订阅行情分时图（1分钟）
impl.kbar_time_seq_req = 1057;
impl.kbar_time_seq_rsp = 1058;


////////////////////////////////////////////////////////////////////////////////
Front.getTopicId = function (targetId, ktype, kunit) {
  return targetId + "#" + ktype + "#" + kunit;
}


////////////////////////////////////////////////////////////////////////////////
// 获取合约的价格精度
Front.prototype.getTargetPrecision = function (targetId) {
  var target = this.targetSet[targetId];
  if (target === undefined) return 0;
  return art.digit(target.priceTick);
}
// 格式化各个信息
Front.prototype.formatKbar = function (kbar) {
  var target = this.targetSet[kbar.targetId];
  if (target === undefined) return;
  var bit = art.digit(target.priceTick);
  kbar.priceOpen = kbar.priceOpen.toFixed(bit);
  kbar.priceClose = kbar.priceClose.toFixed(bit);
  kbar.priceLow = kbar.priceLow.toFixed(bit);
  kbar.priceHigh = kbar.priceHigh.toFixed(bit);
  kbar.priceAverage = kbar.priceAverage.toFixed(bit);
}


////////////////////////////////////////////////////////////////////////////////
/**
 * 订阅行情数据Kbar与分时图数据。
 * @param {String} kReq.targetId 合约代码rb1805。
 * @param {Front.prototype.ktype} kReq.ktype K线类型
 * @param {number} kReq.kunit  K线单位数。
 * @param {Front.prototype.kopt} kReq.koption K线合成选项。
 * @param {Front.prototype.kquery} kReq.kquery K线查询模式。
 * @param {String} kReq.endTime 查询截止的时间单位。
 * @param {String} kReq.startTime 开始时间单元。
 * @param {number} kReq.ksize 查询K线个数/K线天数。
 * @param {Object} suber 订阅者视图
 */
Front.prototype.subKbar2 = function (kReq, suber) {
  let that = this;
  if (!that.ready()) {
    return;
  }
  if (kReq.kquery != Front.prototype.kquery_size &&
    kReq.kquery != Front.prototype.kquery_days &&
    kReq.kquery != Front.prototype.kquery_time) {
    throw new Error("[subkbar] kReq.kquery invalid.");
  }

  // 本地订阅发布管理
  var option = {
    suber: suber,
    topicId: Front.getTopicId(kReq.targetId, kReq.ktype, kReq.kunit),
    topicType: tpc.SeqTopic,
    topicGroup: {
      groupId: "kbar",
      topicId: function (kbar) {
        return Front.getTopicId(kbar.targetId, kbar.ktype, kbar.kunit);
      }
    },
  };

  // 若是第一次订阅数据，则从后台服务器订阅
  var result = that.kbar.subscribe(option);
  if (result.sub) {
    that.websocket.subscribe(impl.kbar_pub, market_pb.Kbar,
      function (pub, snap) {
        that.formatKbar(pub);
        that.kbar.publish(pub, undefined, snap);
      }
    );

    // 构建请求数据
    var req = new market_pb.SubKbar();
    req.reqType = impl.kbar_sub_req;
    req.setTargetId(kReq.targetId);
    req.setKtype(kReq.ktype);
    req.setKunit(kReq.kunit);
    req.setKoption(kReq.koption);
    req.setKquery(kReq.kquery);
    req.setKsize(kReq.ksize);
    req.setEndTime(kReq.endTime);
    req.setStartTime(kReq.startTime);

    // 发送请求数据
    that.websocket.send(req, market_pb.SubKbarRsp, {
      resolve: (suber === undefined) ? suber : suber.resolve,
      reject: (suber === undefined) ? that.onError : suber.reject
    });
  }
  return result.subject;
}


////////////////////////////////////////////////////////////////////////////////
/**
 * 取消订阅行情K线
 * @param {String} kReq.targetId 合约代码rb1805。
 * @param {Front.prototype.ktype} kReq.ktype K线类型
 * @param {number} kReq.kunit  K线单位数。
 * @param {Object} suberId 订阅者视图ID
 */
Front.prototype.unsubKbar2 = function (kReq, suberId) {
  let that = this;
  if (!that.ready()) {
    return;
  }
  // 从主题中移除订阅者
  // 若主题不存在订阅者，则取消服务器端的订阅。
  var topicId = Front.getTopicId(kReq.targetId, kReq.ktype, kReq.kunit);
  var unsubs = this.kbar.unsubscribe(topicId, suberId);
  if (unsubs) {
    var req = new market_pb.SubKbar();
    req.reqType = impl.kbar_unsub_req;
    req.setTargetId(kReq.targetId);
    req.setKtype(kReq.ktype);
    req.setKunit(kReq.kunit);
    that.websocket.send(req, market_pb.SubKbarRsp);
  }
}


////////////////////////////////////////////////////////////////////////////////
/**
 * 查询合约时间序列。
 * @param {String} kreq.targetId 合约代码rb1805。
 * @param {Front.prototype.ktype} kreq.ktype K线类型
 * @param {number} kreq.kunit  K线单位数。
 * @param {Front.prototype.kopt} kreq.resolve K线合成选项。
 * @param {Front.prototype.kquery} kreq.reject K线查询模式。
 */
Front.prototype.getKbarTimeSeq2 = function (kreq) {
  var that = this;
  if (that.ready()) {
    var req = new market_pb.TimeSeqReq();
    req.setTargetId(kreq.targetId);
    req.setKtype(kreq.ktype);
    req.setKunit(kreq.kunit);
    req.reqType = impl.kbar_time_seq_req;
    that.websocket.send(req, market_pb.TimeSeqRsp, {
      resolve: kreq.resolve,
      reject: kreq.reject,
    });
  }
}


////////////////////////////////////////////////////////////////////////////////
/**
 * 订阅行情数据Kbar与分时图数据。
 * @param {String} kReq.targetId 合约代码rb1805。
 * @param {Front.prototype.ktype} kReq.ktype K线类型
 * @param {number} kReq.kunit  K线单位数。
 * @param {Front.prototype.kopt} kReq.koption K线合成选项。
 * @param {Front.prototype.kquery} kReq.kquery K线查询模式。
 * @param {String} kReq.endTime 查询截止的时间单位。
 * @param {String} kReq.startTime 开始时间单元。
 * @param {number} kReq.ksize 查询K线个数/K线天数。
 * @param {Object} suber 订阅者视图
 */
Front.prototype.getKbar2 = function (kReq, on_resolve, on_reject) {
  let that = this;
  if (!that.ready()) {
    return;
  }

  // 构建请求数据
  var req = new market_pb.SubKbar();
  req.reqType = impl.kbar_get_req;
  req.setTargetId(kReq.targetId);
  req.setKtype(kReq.ktype);
  req.setKunit(kReq.kunit);
  req.setKoption(kReq.koption);
  req.setKquery(kReq.kquery);
  req.setKsize(kReq.ksize);
  req.setEndTime(kReq.endTime);
  req.setStartTime(kReq.startTime);

  // 发送请求数据
  var kbar_set = new Array();
  that.websocket.send(req, market_pb.GetKbarRsp, {
    resolve: function (kbar, last) {
      if (kbar) kbar_set.push(kbar);
      if (last) on_resolve(kbar_set);
    },
    reject: function (error) {
      on_reject(error);
    }
  });
}
////////////////////////////////////////////////////////////////////////////////
export default new Front();



// WEBPACK FOOTER //
// ./static/js/proto/CtpFront.js